import React from 'react'
import PropTypes from 'prop-types';
function ResultProtractor({textResult,styleResult}) {
  return (
    <div  style={{
        position: "absolute",
        top: styleResult.top,
        left: styleResult.left,
        backgroundColor: "rgb(89, 188, 141)",
        borderRadius: "50%",
        fontSize:24,
        color: "white",
        padding: "2px 6px",
        // display: "",
    }}>
        {textResult}
    </div>
  )
}

ResultProtractor.propTypes = {
    resultId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    textResult: PropTypes.number.isRequired,
    styleResult: PropTypes.object,
  }
  
export default ResultProtractor
